import { clinicFragment } from 'apollo/fragments/clinic';
import { gql } from 'graphql.macro';

export const addClinicTemplate = gql`
    mutation addClinic($clinic: ClinicInput!) {
        addClinic(clinic: $clinic) {
            ...clinicFields
        }
    }
    ${clinicFragment}
`;

export const addLocalClinicTemplate = gql`
    mutation addLocalClinic($clinic: ClinicInput!) {
        addLocalClinic(clinic: $clinic) {
            ...clinicFields
        }
    }
    ${clinicFragment}
`;

export const modifyClinicTemplate = gql`
    mutation modifyClinic($clinicId: MongoDbObjectId!, $clinic: ClinicInput!) {
        modifyClinic(clinicId: $clinicId, clinic: $clinic) {
            ...clinicFields
        }
    }
    ${clinicFragment}
`;

export const threeShapeClinicLoginTemplate = gql`
    mutation threeShapeClinicLogin($clinicId: MongoDbObjectId!, $authCode: String!) {
        threeShapeClinicLogin(clinicId: $clinicId, authCode: $authCode)
    }
`;

export const threeShapeClinicDeleteLoginTemplate = gql`
    mutation threeShapeClinicDeleteLogin($clinicId: MongoDbObjectId!, $authCode: String!) {
        threeShapeClinicDeleteLogin(clinicId: $clinicId, authCode: $authCode)
    }
`;
